import { render, staticRenderFns } from "./MenuDishSelector.vue?vue&type=template&id=565a3602&scoped=true&"
import script from "./MenuDishSelector.vue?vue&type=script&lang=js&"
export * from "./MenuDishSelector.vue?vue&type=script&lang=js&"
import style0 from "./MenuDishSelector.vue?vue&type=style&index=0&id=565a3602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565a3602",
  null
  
)

export default component.exports